export default "__VITE_ASSET__8acde003__"